module.exports = __webpack_public_path__ + "img/mono_26.dcc44354.png";